<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">business</span>
      <p>
        Consulta y administra la información del centro de atención médica:
        datos generales de la empresa, usuarios del sistema y medios de
        comunicación configurados.
      </p>
    </div>

    <!-- Datos de la empresa -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Datos de la empresa (solo lectura)
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in datosEmpresa" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Pestañas -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">tab</span>
        Pestañas disponibles
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="tab in tabs" :key="tab.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ tab.icon }}</span>
          <div>
            <p class="help-card-title">{{ tab.titulo }}</p>
            <p class="help-card-desc">{{ tab.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Los datos de la empresa (nombre, documento, dirección, localidad) son
        de solo lectura en esta pantalla. Para modificarlos contacta al
        administrador del sistema. La pestaña <strong>Usuarios</strong> solo
        es visible para el suscriptor principal de la empresa.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaEmpresaForm",
  data() {
    return {
      datosEmpresa: [
        {
          icon: "badge",
          titulo: "Nombre corto y documento",
          desc:   "Identificador abreviado de la empresa y su número de documento (RUC o cédula). Ambos son de solo lectura.",
        },
        {
          icon: "location_on",
          titulo: "Localidad",
          desc:   "Localidad o ciudad donde está ubicado el centro de atención.",
        },
        {
          icon: "apartment",
          titulo: "Razón social y nombre",
          desc:   "Nombre legal completo (razón social) y nombre comercial de la empresa.",
        },
        {
          icon: "home",
          titulo: "Dirección",
          desc:   "Dirección física del centro de atención médica.",
        },
        {
          icon: "expand_more",
          titulo: "Más información",
          desc:   "Despliega los IDs de auditoría y las fechas de registro y última actualización del registro de la empresa.",
        },
      ],
      tabs: [
        {
          icon: "manage_accounts",
          titulo: "Usuarios",
          desc:   "Gestiona los usuarios del sistema asociados a la empresa: creación, edición, activación/desactivación y asignación de perfiles. Visible solo para el suscriptor principal.",
        },
        {
          icon: "phone_in_talk",
          titulo: "Medios de Comunicación",
          desc:   "Registra y gestiona los canales de contacto de la empresa: teléfonos, correos electrónicos, sitios web y redes sociales.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>